<template>
	<el-container v-loading.fullscreen.lock="fullscreenLoading">
		<!-- 菜单 -->
		<el-aside width="200px">
			<div class="logo-box">
				<img class="logo" src="../../assets/logo.png" alt="" srcset="" />
			</div>
			<div class="info-box">
				<div class="head-box">
					<img v-if="userInfo.head_img" class="head-img" :src="userInfo.head_img" alt="" srcset="" />
					<img class="head-img" v-else src="../../assets/head.png" >
				</div>
				
				<div>
					<div class="dis-flex al-center">
						<el-popover width="90" popper-class="poperclass" :placement="'bottom'" trigger="click">
							<div style="font-size: 15px;text-align: center;cursor: pointer;">
								<div class="poptxt" @click="dialogVisible = true" style="margin-bottom: 10px;">
									<i class="el-icon-lock" style="font-size: 15px;margin-right: 5px;"></i>
									修改密码
								</div>
								<div class="poptxt" @click="exitLogin">
									<i class="el-icon-switch-button" style="font-size: 15px;margin-right: 5px;"></i>
									退出登录
								</div>
							</div>
							<div id="" slot="reference" style="cursor: pointer;">
								<span>{{ userInfo.username }}</span>
								<i class="el-icon-caret-bottom" style="font-size: 12px;margin-left: 5px;"></i>
								<!-- <i class="el-icon-caret-top" style="font-size: 12px;margin-left: 5px;"></i> -->
							</div>
						</el-popover>
					</div>
					<!-- <div><span>{{ userInfo.auth_title }}</span></div> -->
					<div class="welcome-txt">{{userInfo.auth_title}}</div>
				</div>
			</div>
			<el-menu :unique-opened="true" :router="true" text-color="white">
				<div v-for="(v, k) in menuArr" :key="k">
					<el-menu-item @click="onMenu(v.title)" :index="v.route" 
					v-if="!v.child" style="text-align: left;margin-left: .5px;"
					>
						<i :class="v.icon" style="color: white;"></i>
						<span>{{ v.title }}</span>
					</el-menu-item>
					 <!-- <el-menu-item index="2" v-if="!v.children.length" style="">
						<i class="el-icon-menu"></i>
						<span slot="title">{{v.name}}</span>
					  </el-menu-item> -->
					<el-submenu :index="v.title" v-else style="letter-spacing: 2px;text-align: left;">
						<template slot="title">
							<i :class="v.icon" style="color: white;"></i>
							<span>{{ v.title }}</span>
						</template>
						<el-menu-item @click="onMenu(item.title)" style="padding-left: 60px;"
						:index="item.route" 
						v-for="(item, index) in v.child" 
						:key="index">{{ item.title }}</el-menu-item>
					</el-submenu>
				</div>
			</el-menu>
		</el-aside>
		<!-- 主体内容 -->
		<el-main :style="[isHome == true ? style : style2]">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">
					<span class="menu-bread-box">
						<span class="menu-bread-left"></span>
						<span>{{ elMain.name }}</span>
					</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item v-for="(v, k) in elMain.child" :key="k">
					{{ v.name }}
				</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="line-box"></div>
			<router-view></router-view>
		</el-main>

		<!-- 修改密码弹框 -->
		<el-dialog :destroy-on-close="true" :visible.sync="dialogVisible" width="20%" :before-close="close">
			<div slot="title" class="title">修改密码</div>
			<div>
				<el-form size="small" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="top">
					<el-form-item label="新密码" prop="password"><el-input type="password" show-password v-model="ruleForm.password"></el-input></el-form-item>
					<el-form-item label="确认密码" prop="password_again"><el-input type="password" show-password v-model="ruleForm.password_again"></el-input></el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="small-btn btn-bor" size="small" @click="close">取 消</el-button>
				<el-button class="small-btn bgC" size="small" type="primary" @click="submitForm('ruleForm')">修 改</el-button>
			</span>
		</el-dialog>
	</el-container>
</template>

<script>
export default {
	data() {
		return {
			fullscreenLoading:true,
			ruleForm: {
				password: '',
				password_again: ''
			},
			rules: {
				password: [{ required: true, message: '请输入新密码', trigger: ['blur', 'change'] }],
				password_again: [{ required: true, message: '请输入确认密码', trigger: ['blur', 'change'] }]
			},
			dialogVisible: false,
			showIcon: true,
			userInfo: {},
			isHome: false,
			style: {
				backgroundColor: 'rgb(246, 246, 246)'
			},
			style2: {
				backgroundColor: 'white'
			},
			activeIndex: '1',
			elMain: {
				name: '首页',
				children: []
			},
			menuArr: [
				{
					name: '首页',
					url: '/',
					icon: 'el-icon-s-home',
					children: []
				},
				// {
				// 	name: '消息列表',
				// 	url: '',
				// 	icon: 'el-icon-chat-dot-round',
				// 	children: []
				// },
				{
					name: '订单管理',
					url: '',
					icon: 'el-icon-s-order',
					children: [{ name: '订单列表', url: 'orderList' }, { name: '我的报价', url: 'myOffer' }]
				},
				{
					name: '账号管理',
					url: '',
					icon: 'el-icon-user',
					children: [{ name: '账号列表', url: 'accountList' }, { name: '权限管理', url: 'authority' }]
				},
				{
					name: '报备管理',
					url: '',
					icon: 'el-icon-tickets',
					children: [{ name: '报备列表', url: 'reportList' }]
				},
				{
					name: '计划管理',
					url: '',
					icon: 'el-icon-document',
					children: [
						{ name: '站点列表', url: 'siteList' },
						{ name: '周边列表', url: 'periphery' }
					]
				},
				// {
				// 	name: '工程管理',
				// 	url: '',
				// 	icon: 'el-icon-menu',
				// 	children: [{ name: '账号列表', url: 'accountList' }]
				// }
			]
		};
	},
	created() {
		let menu = JSON.parse(localStorage.getItem('menu'))
		if(!menu){
			this.$api2.getMenu().then((res)=>{
				if(res.code == 1){
					this.menuArr = res.data
					 this.fullscreenLoading = false;
				}else{
					this.$message.error(res.msg)
				}
			})
		}else{
			this.menuArr = menu
			 this.fullscreenLoading = false;
		}
		
		if (this.$route.path == '/') {
			this.isHome = true;
		}
		let userInfo = localStorage.getItem('userInfo');
		if (userInfo) {
			this.userInfo = JSON.parse(userInfo);
		}
	},
	methods: {
		//   关闭弹框
		close() {
			this.dialogVisible = false;
			this.$refs['ruleForm'].resetFields();
		},
		//修改密码
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.ruleForm.password != this.ruleForm.password_again) {
						return this.$message.error('两次密码不一致');
					}
					this.ruleForm.id = JSON.parse(localStorage.getItem('userInfo')).id;
					this.$api.modifyPwd(this.ruleForm).then(res => {
						if (res.code == 1) {
							this.$message.success('修改成功');
							this.dialogVisible = false;
							setTimeout(() => {
								this.$message.error('登录过期，请重新登录！');
								localStorage.clear();
								setTimeout(() => {
									location.href = '/';
								}, 1e3);
							}, 1.5e3);
						} else {
							this.$message.error(res.msg);
						}
					});
				} else {
					this.$message.error('请输入必填项！');
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 退出登录
		exitLogin() {
			this.$confirm('确认退出登录？', '提示')
				.then(() => {
					this.$api.exitLogin().then(res => {
						if (res.code == 1) {
							localStorage.clear();
							location.href = '/login';
						} else {
							this.$message.error(res.msg);
						}
					});
				})
				.catch(() => {});
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
			// this.activeIndex = key
			// if(key.url){
			//     this.elMain.name = key.name
			// }
		},
		onMenu(v) {
			if(v == '消息列表'){
				console.log(123);
				return
			}
			if (v == '首页') {
				this.isHome = true;
				// console.log('首页');
			} else {
				// console.log('其他');
				this.isHome = false;
			}
			
			this.elMain.name = v;
		}
	}
};
</script>

<style lang="scss">
$mainC: #004f9d;
.txtC {
	color: $mainC;
}
.bgC {
	background-color: $mainC;
}
.row-btn {
	border: none;
	padding: 10px 25px;
	margin-right: 10px;
}
.el-container{
	width: 100vw;
}
.el-main {
	color: #333;
	//   text-align: center;
	height: 100vh;
	overflow: auto;
	// margin-left: 25px;
	padding-left: 25px;
	.line-box {
		margin-top: 40px;
	}
}
.menu-bread-box {
	padding-top: 10px;
	height: 22x;
	display: flex;
	align-items: center;
	color: #004f9d;
	font-size: 16px;
	font-weight: bold;
	.menu-bread-left {
		width: 5px;
		background-color: #004f9d;
		height: 18px;
		margin-right: 8px;
	}
}

.el-aside {
	color: white;
	text-align: center;
	background-color: #004f9d;
	.el-icon-arrow-down {
		right: 55px;
	}
}
.el-submenu__title {
	padding-right: 80px;
	letter-spacing: 2px;
}
.el-submenu__title:hover {
	color: #004f9d !important;
}
.menuitem {
	width: 100% !important;
}
.info-box {
	display: flex;
	padding: 20px;
	align-items: center;
	color: white;
	.welcome-txt {
		font-size: 10px;
		padding-top: 15px;
	}
	.head-img {
		background-color: #ced1d6;
		width: 65px;
		height: 65px;
		border-radius: 50%;
		margin-right: 10px;
		margin-left: 5px;
	}
}
.el-menu-item {
	padding: 0 25px;
}
.el-menu-item:hover {
	color: #004f9d !important;
}
.logo-box {
	padding: 25px;
}
.logo {
	width: 100%;
}
.el-menu {
	color: white !important;
	background-color: #004f9d;
	border-right: none;
}
</style>
